import styled from 'styled-components';

export const MobileBonusBannerStyled = styled.div`
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    width: 100%;
    background-image: linear-gradient(270.98deg, #C0FCA3 1.23%, #FFE35F 100%);
`;

export const MobileBonusBannerContentStyled = styled.div`
    padding: 12px;
    color: var(--text-color-dark);
`;

export const MobileBonusBannerContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
`;

export const MobileBonusBannerTitleStyled = styled.div`
    font-weight: 700;
    font-size: 24px;
`;

export const MobileBonusBannerDescriptionStyled = styled.div`
    font-size: 14px;
    font-weight: 300;
    opacity: 0.6;
`;

export const MobileBonusBannerCloseWrapperStyled = styled.div`
    position: absolute;
    top: -6px;
    right: -6px;
    padding: 6px;
`;
